"use client";

import ListingCard from "@/components/listing/ListingCard";
import AdListingModel from "@/models/AdListingModel";
import { Box, styled, Typography } from "@mui/material";
import Section from "../../sell/(ad)/ad/Section";
import CheckIcon from "@mui/icons-material/Check";
import GavelIcon from "@mui/icons-material/Gavel";

const AdGrid = styled(Box)(({ theme }) =>
  theme.unstable_sx({
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: 4,
  }),
);

export function MemberProfilePage({
  activeAds,
  inactiveAds,
  member,
}: {
  activeAds: AdListingModel[];
  inactiveAds: AdListingModel[];
  member: {
    name: string;
    joinedAt: string;
  };
}) {
  return (
    <Box
      sx={{
        backgroundColor: "grey.100",
        flex: "stretch",
      }}
    >
      <Box
        sx={(theme) => ({
          paddingTop: 4,
          paddingBottom: 4,
          paddingLeft: 1,
          paddingRight: 1,
          display: "flex",
          flexDirection: "column",
          gap: 4,
          maxWidth: "1200px",
          margin: "0 auto",
          [theme.breakpoints.down("sm")]: {
            gap: 2,
          },
        })}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            alignItems: "center",
          }}
        >
          <Typography variant="h4" component="h1">
            {member.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            member since {new Date(member.joinedAt).getFullYear()}
          </Typography>
        </Box>

        {activeAds.length > 0 && (
          <Section title="Active Ads" icon={<CheckIcon />}>
            {activeAds.length > 0 && (
              <AdGrid>
                {activeAds.map((ad) => (
                  <ListingCard key={ad.id} ad={ad} />
                ))}
              </AdGrid>
            )}
          </Section>
        )}
        {inactiveAds.length > 0 && (
          <Section title="Inactive Ads" icon={<GavelIcon />}>
            {inactiveAds.length > 0 && (
              <AdGrid>
                {inactiveAds.map((ad) => (
                  <ListingCard key={ad.id} ad={ad} />
                ))}
              </AdGrid>
            )}
          </Section>
        )}
      </Box>
    </Box>
  );
}
